enum FormFieldTypeEnum {
  TEXT = 'text',
  SELECT = 'select',
  AUTOCOMPLETE = 'autocomplete',
  DATE_RANGE = 'dateRange',
}

export default FormFieldTypeEnum;
